import { createContext } from "react";

import { TableContextState } from "./types";

const TableContext = createContext({} as TableContextState);

export default TableContext;
